module.exports = __webpack_public_path__ + "img/halalit_bereshit_no.06559348.png";